import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, IdDescription } from '../../../tms-shared';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class PriceListReferenceService extends BaseReferenceService {
  constructor(protected httpService: HttpService) {
    super('PriceListReference', httpService);
  }

  getForCurrency(currencyId: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForCurrency/${currencyId}`);
  }
}
